import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/sitevisitemptystate.svg'


const _withScopeId = n => (_pushScopeId("data-v-60123a9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-between tw-items-center tw-mb-4" }
const _hoisted_2 = { class: "tw-flex tw-w-[250px]" }
const _hoisted_3 = {
  key: 0,
  class: "tw-grid tw-grid-cols-[repeat(auto-fit,minmax(300px,1fr))] tw-gap-4 tw-flex tw-items-center tw-justify-center tw-min-h-[calc(100vh_-_220px)] sm:tw-min-h-[calc(100vh_-_390px)]"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[650px] tw-space-y-3 tw-flex tw-flex-col tw-items-center tw-justify-center text-center mx-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Empty State"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[24px] tw-font-semibold" }, " You have not yet scheduled any site visits. "),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-gray-600" }, " You have not yet scheduled any site visits. We recommend taking action soon to ensure timely planning and coordination. ")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "tw-grid tw-grid-cols-[repeat(auto-fit,minmax(300px,1fr))] tw-gap-4" }

import SiteVisitCard from "@/core/uni-components/SiteVisitCard.vue";
import Text from "@/core/uni-components/Text.vue";
import InputSelect from "@/core/uni-components/InputSelect.vue";
import { USER_STORE } from "@/store/modules/user";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { SiteVisitStatus } from "@/core/enums/estimateEnum";

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteVisitRequestsPage',
  props: { projectId: { type: Number || String } },
  setup(__props) {

const store = useStore();
const getSiteVisitRequest = ref([]) as any;
const selectStatus = ref("") as any;
const filterSiteVisitRequest = ref([]) as any;

const props = __props;

const requestStatus = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Requested",
    value: SiteVisitStatus.DEFAULT.toString(),
  },
  {
    label: "Accepted",
    value: SiteVisitStatus.ACCEPTED.toString(),
  },
  {
    label: "Rejected",
    value: SiteVisitStatus.REJECTED.toString(),
  },
];
const getAllSiteRequests = async (status = "") => {
  try {
    getSiteVisitRequest.value = await store.dispatch(
      `${JOB_TEMPLATE_STORE}/getSiteRequestAll`,
      {
        projectId: props.projectId,
        status,
      }
    );
  } catch (error) {
    console.log(error);
  }
};

const onChangeStatus = (value: any) => {
  getAllSiteRequests(value);
};

onMounted(async () => {
  await getAllSiteRequests();
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Text, {
        variant: "h4",
        textWeight: "700",
        textColor: "#0C0F4A"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Site Visit Requests ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_select, {
          variant: "outlined",
          class: "custom_selector",
          modelValue: selectStatus.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((selectStatus).value = $event)),
            onChangeStatus
          ],
          items: requestStatus,
          "item-title": "label",
          "item-value": "value",
          "menu-props": { contentClass: 'custom__text__selector' },
          placeholder: "All"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (!getSiteVisitRequest.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSiteVisitRequest.value, (data) => {
        return (_openBlock(), _createBlock(SiteVisitCard, {
          key: data?.id,
          visitData: data,
          typeData: "Project",
          onGetAllRequest: getAllSiteRequests
        }, null, 8, ["visitData"]))
      }), 128))
    ])
  ]))
}
}

})